export const EMAIL_STATISTICS_API = '/api/dashboard/customer/emails/statistics'
